export default __webpack_public_path__ + "static/media/copy.27f6a8e0.svg";